/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { PageStringSection } from "./pageStringSection";

export class SignIn extends PageStringSection {
    button_signIn_label: string = "Labels.lbl_SignIn";
    button_singleSignOn_label: string = "Labels.lbl_SingleSignOn";
    errorMessage_AccountLockedOut: string = "Messages.msg_Error_AccountLockedOut";
    errorMessage_AuthenticationFailed: string = "Messages.msg_Error_AuthenticationFailed";
    errorMessage_Incorrect_UsernamePassword: string = "Messages.msg_YourUsernameOrPasswordIsIncorrect";
    formItem_password_label: string = "Labels.lbl_Password";
    formItem_password_placeholder: string = "Labels.lbl_Password";
    formItem_userName_label: string = "Labels.lbl_LoginUserName";
    formItem_userName_placeholder: string = "Labels.lbl_LoginUserName";
    heading_welcome: string = "Labels.lbl_Welcome";
    link_createAccount_label: string = "Labels.lbl_AccountCreate";
    link_forgotCredentials_label: string = "Messages.msg_AccountForgotCredentials_q";
    text_doNotHaveAccount: string = "Messages.msg_DoNotHaveAccount";
}
